<header>

    <nav class="navbar-custom navbar-expand-sm navbar-toggleable-sm navbar-light bg-custom border-bottom-custom box-shadow mb-3">

        <div class="container-fluid">

            <a class="navbar-brand" [routerLink]="['/']"> <img src="assets/img/logo-prosegur.svg" alt="" class="logo-custom" /></a>

            <button class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target=".navbar-collapse"
                    aria-label="Toggle navigation"
                    [attr.aria-expanded]="isExpanded"
                    (click)="toggle()">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse" [ngClass]="{ show: isExpanded }">

                <ul class="navbar-nav flex-grow text-custom">

                    <div class="spacer-custom"></div>

                    <li class="nav-item" [routerLinkActive]="['link-active']">
                        <a class="nav-link-activator-custom icon-custom" [routerLink]="['/activation']"> {{'MENU.ACTIVATOR' | translate}}</a>
                    </li>

                    <div class="spacer-custom"></div>

                    <li class="nav-item" [routerLinkActive]="['link-active']" *ngIf="user && user.role.roleID != 2">
                        <a class="nav-link-countries-custom icon-custom" [routerLink]="['/countriesData']"> {{'MENU.COUNTRIES' | translate}}</a>
                    </li>

                    <div class="spacer-custom"></div>

                    <div class="dropdown-custom">
                        <a class="nav-link-auditlog-custom icon-custom" href="#"> {{'MENU.AUDITLOGS' | translate}}</a>
                        <div class="dropdown-content-custom" *ngIf="login">
                            <a [routerLink]="['/auditLog/activatorAuditLogs/',0]" *ngIf="user && user.role.roleID != 2"> {{'SUBMENU.ACTIVATOR_AUDIT_LOGS' | translate}}</a>
                            <div class="dropdown-divider-custom"></div>
                            <a routerLinkActive="active" [routerLink]="['/auditLog/countriesAuditLogs/',0,0]"> {{'SUBMENU.COUNTRIES_AUDIT_LOGS' | translate}}</a>
                        </div>
                    </div>

                    <div class="spacer-custom"></div>

                    <div class="dropdown-custom">
                        <a class="nav-link-user-custom icon-custom" href="#">&nbsp;</a>
                        <div class="dropdown-content-custom" *ngIf="login">
                            <a [routerLink]="['/changePass']">{{userDetails.UserName}}</a>
                            <a [routerLink]="['/registration']" *ngIf="user && user.role.roleID == 1">{{'MENU.USER_ADMIN' | translate}}</a>
                            <div class="dropdown-divider-custom"></div>
                            <a [routerLink]="['/']" (click)="onLogout()"><img src="assets/img/logout.svg" alt="" class="wicon-custom" /> {{'USER.LOGOUT' | translate}}</a>
                        </div>
                    </div>

                    <div class="spacer-custom"></div>

                    <li>
                        <div class="navbar-nav flex-grow language">
                            {{'MENU.LANGUAGE' | translate}}
                            <select #langselect (change)="translate.use(langselect.value)">
                                <option *ngFor="let lang of translate.getLangs()" [value]="lang"> {{lang}} </option>
                            </select>
                        </div>
                    </li>

                </ul>

            </div>
        </div>
    </nav>
</header>
